module.exports = __webpack_public_path__ + "img/mo.8854800a.svg";